<template>
  <div class="flex flex-col justify-center items-center">
    <div :id="chatConfig.buttonContainerId" :class="classes"></div>
  </div>
</template>
<script>
import headTag from '@/utils/head-tag';
import {mapGetters} from 'vuex';
export default {
  name: 'LiveChat',
  data() {
    return {
      chatConfig: {
        uuid: ACC.customVariables.liveChat.scriptId,
        tenant: 'dHJla2JpY3ljbGUwMQ',
        channel: ACC.isB2Bsite ? `B2B_${ACC.languageISO}`.toUpperCase() : `B2C_${ACC.languageISO}`.toUpperCase(),
        domain: 'https://vcc-na27.8x8.com',
        path: '/.',
        buttonContainerId: `live-chat-button-${ACC.customVariables.liveChat.scriptId}`,
        align: 'right',
        onInit: this.initLiveChat,
      },
      liveChatBus: null,
    };
  },
  computed: {
    ...mapGetters('compare', ['currentRack']),
    classes() {
      return {
        'live-chat-button': true,
        'mb-1': !this.currentRack?.length,
        'mb-6': this.currentRack?.length,
      };
    },
  },
  mounted() {
    // Looks like 8x8 might need this on the window.
    window.__8x8Chat = this.chatConfig;
    if (this.chatConfig.uuid) {
      headTag.appendAsyncScript(
        'live-chat-script',
        `${this.chatConfig.domain}${this.chatConfig.path}/CHAT/common/js/chat.js`
      );
    }
  },
  methods: {
    /**
     * Callback function called after the chat has been initialized.
     *
     * @param bus The message bus used to publish and subscribe to topics
     */
    initLiveChat(bus) {
      this.liveChatBus = bus;
      let busInfo = {
        'currentUserName': ACC.currentUserName,
        'currentUserEmail': ACC.currentUserEmail,
      };
      if (ACC.isB2Bsite) {
        busInfo['currentB2BUnit'] = ACC.currentB2BUnit;
      }
      bus.publish('customer:set-info', busInfo);
    },
  },
};
</script>
<style scoped lang="scss">
.live-chat-button {
  position: fixed;
  z-index: 16000002; //legacy value
  right: 0.5rem;
  bottom: 0;
}
</style>
